import { constants } from "../../misc/constants";
import Scenario1 from "./Scenario1";
import { SbarUIConfig } from "../../components/ui/SbarUI";
import { TransformUIConfig } from "../../components/ui/TransformUI";
import MedsurgBaseScenarioPart from "../MedsurgBaseScenarioPart";
import { Window508Type } from "../MedsurgBaseScenario";

export default class Scenario1Part8 extends MedsurgBaseScenarioPart {

	chapterIds = {
		chapterCinematic1: 'medsurg-cinematic-1-1',
        chapterCinematic49: 'medsurg-cinematic-1-49',
        chapterCinematic53: 'medsurg-cinematic-1-53',
        chapterCinematic54: 'medsurg-cinematic-1-54',
        chapterCinematic55: 'medsurg-cinematic-1-55',
        chapterCinematic56: 'medsurg-cinematic-1-56',
        chapterCinematic81: 'medsurg-cinematic-1-81',
        chapterCinematic82: 'medsurg-cinematic-1-82',
		//NEED O2 ANIM 45
		//NEED O2 ANIM 90
	}

	constructor(scenario: Scenario1, private onDone: () => void){
		super(scenario);
	}

	private PrInstanceID: string;
	private TalkInstanceID1: string;
	private ActionInstanceID1: string;
	private ActionInstanceID2: string;
	private ActionInstanceID3: string;
	private RememberDisplayed: boolean = false;
	private MoveInstanceID: string;

	private Talk1: boolean = false;
	private Talk2: boolean = false;
	private Action1: boolean = false;
	private Action2: boolean = false;
	private Action3: boolean = false;
	private Action4: boolean = false;
	private Action5: boolean = false;
	private Action6: boolean = false;
	private Action7: boolean = false;
	private Action8: boolean = false;
	private Action11: boolean = false;
	private Action12: boolean = false;
	private Action13: boolean = false;
	private Action14: boolean = false;
	private Action15: boolean = false;
	private Action41: boolean = false;
	private Action42: boolean = false;

	private TalkCount: number = 0;
	private OldTalkCount: number = 0;
	private ActionCount: number = 0;
	private OldActionCount: number = 0;
	private PAbool: boolean = false;
	private PObool: boolean = false;
	private CAbool: boolean = false;

	
	public get partId(): string {
		return constants.scenarios.scenario1.parts.level1Part8.id;
	}

	public get videoUrl(): string[] {
		//return ['./assets/videos/scenario1/video1' + this.scenario.avatarIndx + '.mp4'];
		return ['./assets/videos/scenario1/video10.mp4'];
	}

	public start() {
		const context = this;
		this.RememberDisplayed = false;
		context.segment1Step1IntroWalking();
	}

	private segment1Step1IntroWalking() {
		var context = this;
		this.scenario.destroyAllUIInstances();
		context.scenario.displayHeader();
		this.scenario.playAmbientLoop(this.scenario.audioHall);
		this.playVideoChapter(this.chapterIds.chapterCinematic1, () => {
			context.segment1Step2ContinueRoom1();
		});
    }

	private segment1Step4Remember() {
		var context = this;
		this.scenario.update508Window(Window508Type.Remember);
		this.scenario.displayRemember(() => {
			this.scenario.update508Window(Window508Type.Main);
			this.RememberDisplayed = true;
			context.scenario.destroyAllUIInstances();
			//context.segment1Part5Debrief();
		});
	}
	//use when skipping part for testing
	private skipPart() {
		var context = this;
		context.scenario.hideFooter();
        this.scenario.displayModalPop(
			null,
            'Skipping to End',
            () => {
                context.scenario.destroyAllUIInstances();
                    context.segment1Part5Debrief();
            }
        );
	}

    private segment1Step2ContinueRoom1() {
		this.scenario.destroyAllUIInstances();
        var context = this;
        context.scenario.gameManager.environment.blurFadeIn();
        this.scenario.displayModalPop(
			null,
            "It's time to check in with Mr. Jones.",
            () => {
				this.scenario.stopAmbientLoop();
				this.scenario.playAmbientLoop(this.scenario.audioRoom);
				context.scenario.destroyAllUIInstances();
				this.scenario.gameManager.environment.blurFadeOut();
				this.playVideoChapter(this.chapterIds.chapterCinematic49, () => {}, true);
                context.PreloadUis();
				if(this.RememberDisplayed === false) {
					context.segment1Step4Remember();
				}
				this.scenario.displayFooter(() => this.PrInstanceID, () => this.TalkInstanceID1, () => this.ActionInstanceID1, '2', '1', false, false);
				context.TalkCount = 2;
				context.ActionCount = 1;
				context.getFooterCounts();
            }
        );
    }

	private segment1Part5Debrief() {
		var context = this;
		context.scenario.gameManager.environment.blurFadeOut();
		context.scenario.displayDebrief(5900, () => {
			localStorage.setItem('ignoreResumePopup', 'true');
			window.location.reload();
		}, () => {
			context.segment1StepFinal();
		});
	}

	private segment1StepFinal() {
        var context = this;
		this.scenario.stopAmbientLoop();
		context.scenario.destroyAllUIInstances();
		context.segment1Part5DebriefFinal();
    }

	private segment1Part5DebriefFinal() {
		var context = this;
		context.scenario.unlockNextLevel();
		this.scenario.gameManager.customData.saveData.scenarios[context.scenario.currentLevel+1].lastPartId = 0;
		context.scenario.saveScore();
		context.scenario.displayFinalDebrief(true, 39950, () => {
			localStorage.setItem('ignoreResumePopup', 'false');
			window.location.reload();
		});
	}

    public PreloadUis(shouldHidePatientRecord?: boolean) {
        var context = this;
        this.PrInstanceID = (this.scenario as Scenario1).PrJonesID;
		context.scenario.gameManager.UiManager.updateUIInstance(this.PrInstanceID, {
			onClosed: () => {
				this.scenario.update508Window(Window508Type.Main);
				setTimeout(() => {
					context.scenario.update508Window(Window508Type.Remember);
				}, 500);
				this.scenario.gameManager.UiManager.hideUiInstance(this.PrInstanceID);
				// if(this.RememberDisplayed === false) {
				// 	context.segment1Step4Remember();
				// }
			}
		})

		if(shouldHidePatientRecord) {
			this.scenario.gameManager.UiManager.hideUiInstance(this.PrInstanceID);
		} else {
			setTimeout(() => {
				context.scenario.update508Window(Window508Type.PatientRecord);
			}, 500);
		}

		(this.scenario as Scenario1).PrJonesID = this.PrInstanceID;

		context.TalkInstanceID1 = context.scenario.gameManager.UiManager.createUIInstance(constants.uiNames.TalksActionsUI, {
			toptitle: 'Talk',
			talks: [
				{
					toppx: '50px',
					titletext: 'How are you feeling?',
					onClicked: () => {
						this.segment1TalkFeeling();
					},
					disable: () => this.Talk1
				},
				{
					toppx: '150px',
					titletext: 'On a scale of 0-10, can you rate your pain?',
					onClicked: () => {
						this.segment1TalkRate();
					},
					disable: () => this.Talk2
				}
			],
			onClosed: () => {
				this.scenario.update508Window(Window508Type.Main);
				this.scenario.gameManager.UiManager.hideUiInstance(this.TalkInstanceID1);
			}
		});
		this.scenario.gameManager.UiManager.hideUiInstance(this.TalkInstanceID1);

		this.ActionInstanceID1 = context.scenario.gameManager.UiManager.createUIInstance(constants.uiNames.TalksActionsUI, {
			toptitle: 'Action',
			talks: [
				{
					toppx: '50px',
					titletext: 'Take Vitals',
					onClicked: () => {
						this.segment1ActionVitals();
					},
					disable: () => this.Action1
				}
			],
			onClosed: () => {
				this.scenario.update508Window(Window508Type.Main);
				this.scenario.gameManager.UiManager.hideUiInstance(this.ActionInstanceID1);
			}
		});
		this.scenario.gameManager.UiManager.hideUiInstance(this.ActionInstanceID1);
	}

	private segment1ActionVitals() {
		var context = this;
		this.scenario.gameManager.UiManager.hideUiInstance(this.ActionInstanceID1);
		this.ActionInstanceID2 = context.scenario.gameManager.UiManager.createUIInstance(constants.uiNames.TalksActionsUI, {
			toptitle: 'Take Vitals',
			talks: [
				{
					toppx: '50px',
					titletext: 'Temperature',
					onClicked: () => {
						context.segment1ActionTemperature();
					},
					disable: () => this.Action11
				},
				{
					toppx: '150px',
					titletext: 'Blood Pressure',
					onClicked: () => {
						context.segment1ActionBloodPressure();
					},
					disable: () => this.Action12
				},
				{
					toppx: '250px',
					titletext: 'Pulse',
					onClicked: () => {
						context.segment1ActionPulse();
					},
					disable: () => this.Action13
				},
				{
					toppx: '350px',
					titletext: 'Respirations',
					onClicked: () => {
						context.segment1ActionRespirations();
					},
					disable: () => this.Action14
				},
				{
					toppx: '450px',
					titletext: 'O2 Sat Level',
					onClicked: () => {
						context.segment1ActionSatLevel();
					},
					disable: () => this.Action15
				}
			],
			onClosed: () => {
				this.scenario.gameManager.UiManager.hideUiInstance(this.ActionInstanceID2);
				this.scenario.gameManager.UiManager.showUiInstance(this.ActionInstanceID1);
			}
		});
	}

	private segment1TalkFeeling() {
		var context = this;
		context.scenario.update508Window(Window508Type.TransformUI);
		context.scenario.gameManager.UiManager.hideUiInstance(this.TalkInstanceID1);
		this.MoveInstanceID = context.scenario.gameManager.UiManager.createUIInstance(constants.uiNames.TransformUI, {
			toptitle: 'Talk',
			toppx: '70px',
			loadQuiz: true,
			titletext: 'How are you feeling?',
			isTalks: true,
			scenario: this,
			extBottom: true,
			extText: "I still feel awful. My headache is even worse, and I'm still sweating.",
			onSubmit: (updatedConfig: TransformUIConfig) => {
				if(this.PAbool === false) {
					this.scenario.appendToScenarioDataEntry((this.scenario as Scenario1).jonesNursesID, {
						title: context.scenario.patientAssessment,
					}, context.scenario.allVisits, context.scenario.allHeaders, context.scenario.visit2);
					this.PAbool = true;
				}
				for(var i = 0; i < updatedConfig.quiz.length; i++) {
					var quiz = updatedConfig.quiz[i];
					for(var p = 0; p < quiz.selectedTalkIndices.length; p++) {
						var talk = quiz.talks[quiz.selectedTalkIndices[p]];
						this.scenario.appendToScenarioDataEntry((this.scenario as Scenario1).jonesNursesID, {
							header: p === 0 ? quiz.talktext2 : undefined,
							list: '<li>'+talk.buttontext+'</li>',
						}, context.scenario.allVisits, context.scenario.allHeaders, context.scenario.visit2, context.scenario.patientAssessment)
					}
				}

				this.scenario.evaluateScoreForTalk(updatedConfig);
				this.Talk1 = true;
				this.TalkCount = this.OldTalkCount - 1;
				setTimeout(() => {
					context.scenario.update508Window(Window508Type.TalkActionsUI);
				}, 1000);
				this.hideMoveShowTalk(this.MoveInstanceID, this.TalkInstanceID1, () => {
					context.getFooterCounts();
				});
			},
			quiz: [
				{
					quizheight: 4,
					quiztop: '5px',
					maxPoints: 150,
					talktext1: 'Patient Assessment',
					talktext2: 'General',
					talks: [
						{
							buttontop: '150px',
							buttontext: 'Headache',
							isCorrect: true,
							onClicked: () => {
							},
						},
						{
							buttontop: '200px',
							buttontext: 'Nausea',
							onClicked: () => {
							},
						},
						{
							buttontop: '250px',
							buttontext: 'Trembling',
							onClicked: () => {
							},
						},
						{
							buttontop: '300px',
							buttontext: 'Sweating',
							isCorrect: true,
							onClicked: () => {
							},
						}
					]
				},
				{
					quizheight: 5,
					prequizheight: 4,
					quiztop: '520px',
					maxPoints: 100,
					talktext1: 'Patient Assessment',
					talktext2: 'Pain Location',
					talks: [
						{
							buttontop: '150px',
							buttontext: 'General',
							isCorrect: true,
							onClicked: () => {
							},
						},
						{
							buttontop: '200px',
							buttontext: 'Surgical Site',
							onClicked: () => {
							},
						},
						{
							buttontop: '250px',
							buttontext: 'Abdominal',
							onClicked: () => {
							},
						},
						{
							buttontop: '300px',
							buttontext: 'Head',
							isCorrect: true,
							onClicked: () => {
							},
						},
						{
							buttontop: '350px',
							buttontext: 'Chest',
							onClicked: () => {
							},
						}
					]
				}
			]
		});
		setTimeout(() => {
			this.scenario.gameManager.UiManager.updateUIInstance(this.MoveInstanceID, {
				loadQuiz: false,
			});
		}, 2000);
		this.playVideoChapter(this.chapterIds.chapterCinematic55, () => {
			this.playVideoChapter(this.chapterIds.chapterCinematic49, () => {}, true);
		});
	}

	private segment1TalkRate() {
		var context = this;
		context.scenario.update508Window(Window508Type.TransformUI);
		context.scenario.gameManager.UiManager.hideUiInstance(this.TalkInstanceID1);
		this.MoveInstanceID = context.scenario.gameManager.UiManager.createUIInstance(constants.uiNames.TransformUI, {
			toptitle: 'Talk',
			toppx: '170px',
			loadQuiz: true,
			titletext: 'On a scale of 0-10, can you rate your pain?',
			isTalks: true,
			isPainScale: true,
			painScaleMaxPoints: 100,
			scenario: this,
			painScaleCorrect: 8,
			extBottom: true,
			extText: "Maybe an 8 - it's worse than before.",
			onSubmit: (updatedConfig: TransformUIConfig) => {
				this.scenario.evaluateScoreForPainScale(updatedConfig);
				if(this.PAbool === false) {
					this.scenario.appendToScenarioDataEntry((this.scenario as Scenario1).jonesNursesID, {
						title: context.scenario.patientAssessment,
					}, context.scenario.allVisits, context.scenario.allHeaders, context.scenario.visit2);
					this.PAbool = true;
				}
				this.scenario.appendToScenarioDataEntry((this.scenario as Scenario1).jonesNursesID, {
					header: 'Pain Scale',
					list: '<li>'+updatedConfig.painAssessment+'</li>',
				}, context.scenario.allVisits, context.scenario.allHeaders, context.scenario.visit2, context.scenario.patientAssessment)
				this.Talk2 = true;
				this.TalkCount = this.OldTalkCount - 1;
				setTimeout(() => {
					context.scenario.update508Window(Window508Type.TalkActionsUI);
				}, 1000);
				this.hideMoveShowTalk(this.MoveInstanceID, this.TalkInstanceID1, () => {
					context.getFooterCounts();
				});
			},
			quiz: [
			]
		});
		setTimeout(() => {
			this.scenario.gameManager.UiManager.updateUIInstance(this.MoveInstanceID, {
				move: 'translate(0, -100px)',
				time: '2s'
			});
		}, 100);
		setTimeout(() => {
			this.scenario.gameManager.UiManager.updateUIInstance(this.MoveInstanceID, {
				loadQuiz: false,
			});
		}, 2000);
		this.playVideoChapter(this.chapterIds.chapterCinematic56, () => {
			this.playVideoChapter(this.chapterIds.chapterCinematic49, () => {}, true);
		});
	}

	private segment1ActionTemperature() {
		var context = this;
		context.scenario.update508Window(Window508Type.TransformUI);
		context.scenario.gameManager.UiManager.hideUiInstance(this.ActionInstanceID2);
		this.MoveInstanceID = context.scenario.gameManager.UiManager.createUIInstance(constants.uiNames.TransformUI, {
			toptitle: 'Action',
			toppx: '70px',
			scenario: this,
			loadQuiz: true,
			titletext: 'Temperature',
			vitaltext: '98.7',
			vitalimg: './assets/images/general/icons/vitals/icon_vitals_temp.png',
			onSubmit: () => {
				this.Action11 = true;
				this.scenario.appendToScenarioDataEntry((this.scenario as Scenario1).jonesVitalsID, {
					list: '<li>Temperature : 98.7</li>',
				})
				setTimeout(() => {
					context.scenario.update508Window(Window508Type.TalkActionsUI);
				}, 1000);
				context.scenario.updateScore(100);
				context.scenario.gameManager.UiManager.hideUiInstance(this.MoveInstanceID);
				context.scenario.gameManager.UiManager.showUiInstance(this.ActionInstanceID2);
				context.checkIfSubMenu();
			}
		});
		setTimeout(() => {
			this.scenario.gameManager.UiManager.updateUIInstance(this.MoveInstanceID, {
				loadQuiz: false,
			});
		}, 2000);
	}

	private segment1ActionBloodPressure() {
		var context = this;
		context.scenario.update508Window(Window508Type.TransformUI);
		context.scenario.gameManager.UiManager.hideUiInstance(this.ActionInstanceID2);
		this.MoveInstanceID = context.scenario.gameManager.UiManager.createUIInstance(constants.uiNames.TransformUI, {
			toptitle: 'Action',
			scenario: this,
			toppx: '170px',
			loadQuiz: true,
			titletext: 'Blood Pressure',
			vitaltext: '194/100',
			vitalimg: './assets/images/general/icons/vitals/icon_vitals_bp.png',
			onSubmit: () => {
				this.Action12 = true;
				this.scenario.appendToScenarioDataEntry((this.scenario as Scenario1).jonesVitalsID, {
					list: '<li>Blood Pressure : 194/100</li>',
				})
				setTimeout(() => {
					context.scenario.update508Window(Window508Type.TalkActionsUI);
				}, 1000);
				context.scenario.updateScore(100);
				context.scenario.gameManager.UiManager.hideUiInstance(this.MoveInstanceID);
				context.scenario.gameManager.UiManager.showUiInstance(this.ActionInstanceID2);
				context.checkIfSubMenu();
			}
		});
		setTimeout(() => {
			this.scenario.gameManager.UiManager.updateUIInstance(this.MoveInstanceID, {
				move: 'translate(0, -100px)',
				time: '2s'
			});
		}, 100);
		setTimeout(() => {
			this.scenario.gameManager.UiManager.updateUIInstance(this.MoveInstanceID, {
				loadQuiz: false,
			});
		}, 2000);
	}

	private segment1ActionPulse() {
		var context = this;
		context.scenario.update508Window(Window508Type.TransformUI);
		context.scenario.gameManager.UiManager.hideUiInstance(this.ActionInstanceID2);
		this.MoveInstanceID = context.scenario.gameManager.UiManager.createUIInstance(constants.uiNames.TransformUI, {
			toptitle: 'Action',
			toppx: '270px',
			loadQuiz: true,
			scenario: this,
			titletext: 'Pulse',
			vitaltext: '102',
			vitalimg: './assets/images/general/icons/vitals/icon_vitals_pulse.png',
			onSubmit: () => {
				this.Action13 = true;
				this.scenario.appendToScenarioDataEntry((this.scenario as Scenario1).jonesVitalsID, {
					list: '<li>Pulse : 102</li>',
				})
				setTimeout(() => {
					context.scenario.update508Window(Window508Type.TalkActionsUI);
				}, 1000);
				context.scenario.updateScore(100);
				context.scenario.gameManager.UiManager.hideUiInstance(this.MoveInstanceID);
				context.scenario.gameManager.UiManager.showUiInstance(this.ActionInstanceID2);
				context.checkIfSubMenu();
			}
		});
		setTimeout(() => {
			this.scenario.gameManager.UiManager.updateUIInstance(this.MoveInstanceID, {
				move: 'translate(0, -200px)',
				time: '2s'
			});
		}, 100);
		setTimeout(() => {
			this.scenario.gameManager.UiManager.updateUIInstance(this.MoveInstanceID, {
				loadQuiz: false,
			});
		}, 2000);
	}

	private segment1ActionRespirations() {
		var context = this;
		context.scenario.update508Window(Window508Type.TransformUI);
		context.scenario.gameManager.UiManager.hideUiInstance(this.ActionInstanceID2);
		this.MoveInstanceID = context.scenario.gameManager.UiManager.createUIInstance(constants.uiNames.TransformUI, {
			toptitle: 'Action',
			toppx: '370px',
			loadQuiz: true,
			scenario: this,
			titletext: 'Respirations',
			vitaltext: '26',
			vitalimg: './assets/images/general/icons/vitals/icon_vitals_respiration.png',
			onSubmit: () => {
				this.Action14 = true;
				this.scenario.appendToScenarioDataEntry((this.scenario as Scenario1).jonesVitalsID, {
					list: '<li>Respirations : 26</li>',
				})
				setTimeout(() => {
					context.scenario.update508Window(Window508Type.TalkActionsUI);
				}, 1000);
				context.scenario.updateScore(100);
				context.scenario.gameManager.UiManager.hideUiInstance(this.MoveInstanceID);
				context.scenario.gameManager.UiManager.showUiInstance(this.ActionInstanceID2);
				context.checkIfSubMenu();
			}
		});
		setTimeout(() => {
			this.scenario.gameManager.UiManager.updateUIInstance(this.MoveInstanceID, {
				move: 'translate(0, -300px)',
				time: '2s'
			});
		}, 100);
		setTimeout(() => {
			this.scenario.gameManager.UiManager.updateUIInstance(this.MoveInstanceID, {
				loadQuiz: false,
			});
		}, 2000);
	}

	private segment1ActionSatLevel() {
		var context = this;
		context.scenario.update508Window(Window508Type.TransformUI);
		context.scenario.gameManager.UiManager.hideUiInstance(this.ActionInstanceID2);
		this.MoveInstanceID = context.scenario.gameManager.UiManager.createUIInstance(constants.uiNames.TransformUI, {
			toptitle: 'Action',
			toppx: '470px',
			loadQuiz: true,
			scenario: this,
			titletext: 'O2 Sat Level',
			vitaltext: '92%',
			vitalimg: './assets/images/general/icons/vitals/icon_vitals_o2.png',
			onSubmit: () => {
				this.Action15 = true;
				this.scenario.appendToScenarioDataEntry((this.scenario as Scenario1).jonesVitalsID, {
					list: '<li>02 Sat Level : 92%</li>',
				})
				setTimeout(() => {
					context.scenario.update508Window(Window508Type.TalkActionsUI);
				}, 1000);
				context.scenario.updateScore(100);
				context.scenario.gameManager.UiManager.hideUiInstance(this.MoveInstanceID);
				context.scenario.gameManager.UiManager.showUiInstance(this.ActionInstanceID2);
				context.checkIfSubMenu();
			}
		});
		setTimeout(() => {
			this.scenario.gameManager.UiManager.updateUIInstance(this.MoveInstanceID, {
				move: 'translate(0, -400px)',
				time: '2s'
			});
		}, 100);
		setTimeout(() => {
			this.scenario.gameManager.UiManager.updateUIInstance(this.MoveInstanceID, {
				loadQuiz: false,
			});
		}, 2000);
	}

	private getFooterCounts() {
		var context = this;
		this.OldTalkCount = this.TalkCount;
		this.OldActionCount = this.ActionCount;
		if(this.TalkCount === 0 && this.ActionCount === 0) {
			context.scenario.updateFooter('0', '0', true, true);
			context.scenario.gameManager.UiManager.hideAllUis([constants.uiTags.Hud]);
			context.scenario.update508Window(Window508Type.Main);
			context.segment2PreloadUis();
		}
		else if(this.TalkCount === 0 && this.ActionCount !== 0) {
			context.scenario.updateFooter('0', this.ActionCount.toString(), true, false);
			context.scenario.update508Window(Window508Type.Main);
			context.scenario.gameManager.UiManager.hideUiInstance(this.TalkInstanceID1);
		}
		else if(this.TalkCount !== 0 && this.ActionCount === 0) {
			context.scenario.updateFooter(this.TalkCount.toString(), '0', false, true);
			context.scenario.update508Window(Window508Type.Main);
			context.scenario.gameManager.UiManager.hideUiInstance(this.ActionInstanceID1);
		}
		else {
			context.scenario.updateFooter(this.TalkCount.toString(), this.ActionCount.toString(), false, false)
		};
	}

	private checkIfSubMenu() {
		var context = this;
		if(this.Action11 === true && this.Action12 === true && this.Action13 === true && this.Action14 === true && this.Action15 === true) {
			context.scenario.gameManager.UiManager.hideAllUis([constants.uiTags.Hud]);
			this.scenario.gameManager.UiManager.showUiInstance(this.ActionInstanceID1);
			this.Action1 = true;
			this.ActionCount = this.OldActionCount - 1;
		};
		context.getFooterCounts();
	}

	private segment2PreloadUis() {
        var context = this;
		context.scenario.gameManager.UiManager.updateUIInstance(this.ActionInstanceID1, {
			talks: [
				{
					toppx: '50px',
					titletext: 'Administer Supplemental O2',
					onClicked: () => {
						this.segment1ActionO2();
					},
					disable: () => this.Action2
				}
			]
		});
		this.scenario.gameManager.UiManager.hideUiInstance(this.ActionInstanceID1);

		context.ActionCount = 1;
		context.TalkCount = 0;
		context.getFooterCounts2();
	}

	private segment1ActionO2() {
		var context = this;
		context.scenario.update508Window(Window508Type.TransformUI);
		context.scenario.gameManager.environment.blurFadeIn();
		context.scenario.gameManager.UiManager.hideUiInstance(this.ActionInstanceID1);
		this.MoveInstanceID = context.scenario.gameManager.UiManager.createUIInstance(constants.uiNames.TransformUI, {
			toptitle: 'Action',
			toppx: '70px',
			loadQuiz: true,
			scenario: this,
			titletext: 'Administer Supplemental O2.',
			isTalks: true,
			onSubmit: () => {
				context.scenario.updateScore(250);
				context.scenario.gameManager.environment.blurFadeOut();
				setTimeout(() => {
					context.scenario.update508Window(Window508Type.TalkActionsUI);
				}, 1000);
				this.Action2 = true;
				this.ActionCount = this.OldActionCount - 1;
				//NEED O2 ANIM LOOP 45, replace loops below
				this.playVideoChapter(this.chapterIds.chapterCinematic81, () => {}, true);context.scenario.gameManager.UiManager.hideUiInstance(this.MoveInstanceID);
				context.scenario.gameManager.UiManager.showUiInstance(this.ActionInstanceID1);
				context.getFooterCounts2();
			},
			quiz: [
			]
		});
		setTimeout(() => {
			this.scenario.gameManager.UiManager.updateUIInstance(this.MoveInstanceID, {
				loadQuiz: false,
			});
		}, 2000);
	}

	private getFooterCounts2() {
		var context = this;
		this.OldTalkCount = this.TalkCount;
		this.OldActionCount = this.ActionCount;
		if(this.TalkCount === 0 && this.ActionCount === 0) {
			context.scenario.updateFooter('0', '0', true, true);
			context.scenario.gameManager.UiManager.hideAllUis([constants.uiTags.Hud]);
			context.scenario.update508Window(Window508Type.Main);
			context.segment25PreloadUis();
		}
		else if(this.TalkCount === 0 && this.ActionCount !== 0) {
			context.scenario.updateFooter('0', this.ActionCount.toString(), true, false);
			context.scenario.update508Window(Window508Type.Main);
			context.scenario.gameManager.UiManager.hideUiInstance(this.TalkInstanceID1);
		}
		else if(this.TalkCount !== 0 && this.ActionCount === 0) {
			context.scenario.updateFooter(this.TalkCount.toString(), '0', false, true);
			context.scenario.update508Window(Window508Type.Main);
			context.scenario.gameManager.UiManager.hideUiInstance(this.ActionInstanceID1);
		}
		else {
			context.scenario.updateFooter(this.TalkCount.toString(), this.ActionCount.toString(), false, false)
		};
	}

	private segment25PreloadUis() {
        var context = this;
		context.scenario.gameManager.UiManager.updateUIInstance(this.ActionInstanceID1, {
			talks: [
				{
					toppx: '50px',
					titletext: 'Adjust Bed',
					onClicked: () => {
						this.segment2ActionBed();
					},
					disable: () => this.Action3
				}
			]
		});
		this.scenario.gameManager.UiManager.hideUiInstance(this.ActionInstanceID1);

		context.ActionCount = 1;
		context.TalkCount = 0;
		context.getFooterCounts25();
	}

	private segment2ActionBed() {
		var context = this;
		context.scenario.update508Window(Window508Type.TransformUI);
		context.scenario.gameManager.environment.blurFadeIn();
		context.scenario.gameManager.UiManager.hideUiInstance(this.ActionInstanceID1);
		this.MoveInstanceID = context.scenario.gameManager.UiManager.createUIInstance(constants.uiNames.TransformUI, {
			toptitle: 'Action',
			toppx: '70px',
			loadQuiz: true,
			scenario: this,
			titletext: 'Adjust Bed',
			isTalks: true,
			onSubmit: (updatedConfig: TransformUIConfig) => {
				this.scenario.evaluateScoreForTalk(updatedConfig);
			},
			quiz: [
				{
					quizheight: 4,
					quiztop: '5px',
					binaryq: true,
					talktext1: ' ',
					talktext2: 'Adjust Bed',
					talks: [
						{
							buttontop: '150px',
							buttontext: 'Supine',
							isCorrect: true,
							onClicked: () => {
							},
						},
						{
							buttontop: '200px',
							buttontext: 'Semi-Fowlers',
							onClicked: () => {
							},
						},
						{
							buttontop: '250px',
							buttontext: 'High Fowlers',
							onClicked: () => {
							},
						},
						{
							buttontop: '300px',
							buttontext: 'Trendelenburg',
							onClicked: () => {
							},
						}
					],
					setFailed: true,
					failedOnDone: () => {
						context.scenario.gameManager.UiManager.hideUiInstance(this.MoveInstanceID);
						this.scenario.displayModalPop(
							null,
							'That is the incorrect bed position for assessing the bladder. Try again.',
							() => {
								context.scenario.destroyAllUIInstances();
								context.segment2ActionBed();
							}
						);
					},
					passedOnDone: () => {
						context.scenario.updateScore(100);
						context.scenario.gameManager.environment.blurFadeOut();
						//NEED O2 ANIM LOOP 90, replace loops below
						this.playVideoChapter(this.chapterIds.chapterCinematic82, () => {}, true);
						this.Action3 = true;
						this.ActionCount = this.OldActionCount - 1;
						context.scenario.gameManager.UiManager.hideUiInstance(this.MoveInstanceID);
						context.getFooterCounts25();
					}
				}
			]
		});
		setTimeout(() => {
			this.scenario.gameManager.UiManager.updateUIInstance(this.MoveInstanceID, {
				loadQuiz: false,
			});
		}, 2000);
	}

	private getFooterCounts25() {
		var context = this;
		this.OldTalkCount = this.TalkCount;
		this.OldActionCount = this.ActionCount;
		if(this.TalkCount === 0 && this.ActionCount === 0) {
			context.scenario.updateFooter('0', '0', true, true);
			context.scenario.gameManager.UiManager.hideAllUis([constants.uiTags.Hud]);
			context.scenario.update508Window(Window508Type.Main);
			context.segment3PreloadUis();
		}
		else {
			context.scenario.updateFooter('0', this.ActionCount.toString(), true, false)
		};
	}

	private segment3PreloadUis() {
        var context = this;
		context.scenario.gameManager.UiManager.updateUIInstance(this.ActionInstanceID1, {
			talks: [
				{
					toppx: '50px',
					titletext: 'Assess Patient',
					onClicked: () => {
						this.segment3ActionAssess();
					},
					disable: () => this.Action4
				}
			]
		});
		this.scenario.gameManager.UiManager.hideUiInstance(this.ActionInstanceID1);

		context.ActionCount = 2;
		context.TalkCount = 0;
		context.getFooterCounts3();
	}

	private segment3ActionAssess() {
		var context = this;
		this.scenario.gameManager.UiManager.hideUiInstance(this.ActionInstanceID1);
		this.ActionInstanceID3 = context.scenario.gameManager.UiManager.createUIInstance(constants.uiNames.TalksActionsUI, {
			toptitle: 'Assess Patient',
			talks: [
				{
					toppx: '50px',
					titletext: 'Bladder',
					onClicked: () => {
						context.segment1ActionBladder();
					},
					disable: () => this.Action41
				},
				{
					toppx: '150px',
					titletext: 'Catheter: Check Urine Output',
					onClicked: () => {
						context.segment1ActionUrine();
					},
					disable: () => this.Action42
				}
			],
			onClosed: () => {
				this.scenario.gameManager.UiManager.hideUiInstance(this.ActionInstanceID3);
				this.scenario.gameManager.UiManager.showUiInstance(this.ActionInstanceID1);
			}
		});
	}

	private segment1ActionBladder() {
		var context = this;
		context.scenario.update508Window(Window508Type.TransformUI);
		context.scenario.gameManager.UiManager.hideUiInstance(this.ActionInstanceID3);
		this.MoveInstanceID = context.scenario.gameManager.UiManager.createUIInstance(constants.uiNames.TransformUI, {
			toptitle: 'Assess Patient',
			toppx: '70px',
			scenario: this,
			loadQuiz: true,
			titletext: "Bladder",
			isTalks: true,
			extTop: true,
			extImg: 'AssessingAbdominal',
			extText: 'Bladder feels firm, taught, and distended.',
			onSubmit: (updatedConfig: TransformUIConfig) => {
				if(this.PObool === false) {
					this.scenario.appendToScenarioDataEntry((this.scenario as Scenario1).jonesNursesID, {
						title: context.scenario.patientObservation,
					}, context.scenario.allVisits, context.scenario.allHeaders, context.scenario.visit2);
					this.PObool = true;
				}
				for(var i = 0; i < updatedConfig.quiz.length; i++) {
					var quiz = updatedConfig.quiz[i];
					for(var p = 0; p < quiz.selectedTalkIndices.length; p++) {
						var talk = quiz.talks[quiz.selectedTalkIndices[p]];
						this.scenario.appendToScenarioDataEntry((this.scenario as Scenario1).jonesNursesID, {
							header: p === 0 ? quiz.talktext2 : undefined,
							list: '<li>'+talk.buttontext+'</li>',
						}, context.scenario.allVisits, context.scenario.allHeaders, context.scenario.visit2, context.scenario.patientObservation)
					}
				}

				this.scenario.evaluateScoreForTalk(updatedConfig);
				this.Action41 = true;
				this.ActionCount = this.OldActionCount - 1;
				setTimeout(() => {
					context.scenario.update508Window(Window508Type.TalkActionsUI);
				}, 1000);
				context.scenario.gameManager.UiManager.hideUiInstance(this.MoveInstanceID);
				context.scenario.gameManager.UiManager.showUiInstance(this.ActionInstanceID3);
				context.checkIfSubMenu2();
			},
			quiz: [
				{
					quizheight: 4,
					quiztop: '5px',
					maxPoints: 500,
					binaryq: true,
					talktext1: 'Patient Observation',
					talktext2: 'Bladder',
					talks: [
						{
							buttontop: '150px',
							buttontext: 'Normal',
							onClicked: () => {
							},
						},
						{
							buttontop: '200px',
							buttontext: 'Mild Distension',
							onClicked: () => {
							},
						},
						{
							buttontop: '250px',
							buttontext: 'Moderate Distension',
							onClicked: () => {
							},
						},
						{
							buttontop: '300px',
							buttontext: 'Severe Distension',
							isCorrect: true,
							onClicked: () => {
							},
						}
					]
				}
			]
		});
		setTimeout(() => {
			this.scenario.gameManager.UiManager.updateUIInstance(this.MoveInstanceID, {
				loadQuiz: false,
			});
		}, 2000);
	}

	private segment1ActionUrine() {
		var context = this;
		context.scenario.update508Window(Window508Type.TransformUI);
		context.scenario.gameManager.UiManager.hideUiInstance(this.ActionInstanceID3);
		this.MoveInstanceID = context.scenario.gameManager.UiManager.createUIInstance(constants.uiNames.TransformUI, {
			toptitle: 'Assess Patient',
			toppx: '170px',
			scenario: this,
			loadQuiz: true,
			titletext: "Catheter: Check Urine Output",
			isTalks: true,
			extTop: true,
			extImg: 't6',
			extText: '500 ml',
			onSubmit: (updatedConfig: TransformUIConfig) => {
				if(this.CAbool === false) {
					this.scenario.appendToScenarioDataEntry((this.scenario as Scenario1).jonesNursesID, {
						title: context.scenario.catheter,
					}, context.scenario.allVisits, context.scenario.allHeaders, context.scenario.visit2);
					this.CAbool = true;
				}
				for(var i = 0; i < updatedConfig.quiz.length; i++) {
					var quiz = updatedConfig.quiz[i];
					for(var p = 0; p < quiz.selectedTalkIndices.length; p++) {
						var talk = quiz.talks[quiz.selectedTalkIndices[p]];
						this.scenario.appendToScenarioDataEntry((this.scenario as Scenario1).jonesNursesID, {
							header: p === 0 ? quiz.talktext2 : undefined,
							list: '<li>'+talk.buttontext+'</li>',
						}, context.scenario.allVisits, context.scenario.allHeaders, context.scenario.visit2, context.scenario.catheter)
					}
				}

				this.scenario.evaluateScoreForTalk(updatedConfig);
				this.Action42 = true;
				this.ActionCount = this.OldActionCount - 1;
				setTimeout(() => {
					context.scenario.update508Window(Window508Type.TalkActionsUI);
				}, 1000);
				context.scenario.gameManager.UiManager.hideUiInstance(this.MoveInstanceID);
				context.scenario.gameManager.UiManager.showUiInstance(this.ActionInstanceID3);
				context.checkIfSubMenu2();
			},
			quiz: [
				{
					quizheight: 4,
					quiztop: '5px',
					maxPoints: 500,
					talktext1: 'Catheter',
					talktext2: 'Urine Output',
					talks: [
						{
							buttontop: '150px',
							buttontext: '1500 ml',
							onClicked: () => {
							},
						},
						{
							buttontop: '200px',
							buttontext: '500 ml',
							isCorrect: true,
							onClicked: () => {
							},
						},
						{
							buttontop: '250px',
							buttontext: '100 ml',
							onClicked: () => {
							},
						},
						{
							buttontop: '300px',
							buttontext: '0 ml',
							onClicked: () => {
							},
						}
					]
				}
			]
		});
		setTimeout(() => {
			this.scenario.gameManager.UiManager.updateUIInstance(this.MoveInstanceID, {
				move: 'translate(0, -100px)',
				time: '2s'
			});
		}, 100);
		setTimeout(() => {
			this.scenario.gameManager.UiManager.updateUIInstance(this.MoveInstanceID, {
				loadQuiz: false,
			});
		}, 2000);
	}

	private getFooterCounts3() {
		var context = this;
		this.OldTalkCount = this.TalkCount;
		this.OldActionCount = this.ActionCount;
		if(this.TalkCount === 0 && this.ActionCount === 0) {
			context.scenario.updateFooter('0', '0', true, true);
			context.scenario.gameManager.UiManager.hideAllUis([constants.uiTags.Hud]);
			context.scenario.update508Window(Window508Type.Main);
			context.segment4PreloadUis();
		}
		else {
			context.scenario.updateFooter('0', this.ActionCount.toString(), true, false)
		};
	}

	private checkIfSubMenu2() {
		var context = this;
		if(this.Action41 === true && this.Action42 === true) {
			context.scenario.gameManager.UiManager.hideAllUis([constants.uiTags.Hud]);
			this.scenario.gameManager.UiManager.showUiInstance(this.ActionInstanceID1);
			this.Action4 = true;
		};
		context.getFooterCounts3();
	}

	private segment4PreloadUis() {
        var context = this;
		context.scenario.gameManager.UiManager.updateUIInstance(this.ActionInstanceID1, {
			talks: [
				{
					toppx: '50px',
					titletext: 'Catheter: Check Tube',
					onClicked: () => {
						this.segment4ActionTube();
					},
					disable: () => this.Action5
				}
			]
		});
		this.scenario.gameManager.UiManager.hideUiInstance(this.ActionInstanceID1);

		context.ActionCount = 1;
		context.TalkCount = 0;
		context.getFooterCounts4();
	}

	private segment4ActionTube() {
		var context = this;
		context.scenario.update508Window(Window508Type.TransformUI);
		context.scenario.gameManager.UiManager.hideUiInstance(this.ActionInstanceID1);
		this.MoveInstanceID = context.scenario.gameManager.UiManager.createUIInstance(constants.uiNames.TransformUI, {
			toptitle: 'Actions',
			toppx: '70px',
			scenario: this,
			loadQuiz: true,
			titletext: "Catheter: Check Tube",
			isTalks: true,
			extTop: true,
			extImg: 'PDEquipmentStepOne',
			extText: 'Unkinked',
			onSubmit: (updatedConfig: TransformUIConfig) => {
				if(this.CAbool === false) {
					this.scenario.appendToScenarioDataEntry((this.scenario as Scenario1).jonesNursesID, {
						title: context.scenario.catheter,
					}, context.scenario.allVisits, context.scenario.allHeaders, context.scenario.visit2);
					this.CAbool = true;
				}
				for(var i = 0; i < updatedConfig.quiz.length; i++) {
					var quiz = updatedConfig.quiz[i];
					for(var p = 0; p < quiz.selectedTalkIndices.length; p++) {
						var talk = quiz.talks[quiz.selectedTalkIndices[p]];
						this.scenario.appendToScenarioDataEntry((this.scenario as Scenario1).jonesNursesID, {
							header: p === 0 ? quiz.talktext2 : undefined,
							list: '<li>'+talk.buttontext+'</li>',
						}, context.scenario.allVisits, context.scenario.allHeaders, context.scenario.visit2, context.scenario.catheter)
					}
				}

				this.scenario.evaluateScoreForTalk(updatedConfig);
				this.Action5 = true;
				this.ActionCount = this.OldActionCount - 1;
				setTimeout(() => {
					context.scenario.update508Window(Window508Type.TalkActionsUI);
				}, 1000);
				context.scenario.gameManager.UiManager.hideUiInstance(this.MoveInstanceID);
				context.scenario.gameManager.UiManager.showUiInstance(this.ActionInstanceID1);
				context.getFooterCounts4();
			},
			quiz: [
				{
					quizheight: 3,
					quiztop: '5px',
					maxPoints: 750,
					binaryq: true,
					talktext1: 'Catheter',
					talktext2: 'Tube',
					talks: [
						{
							buttontop: '150px',
							buttontext: 'Kinked',
							onClicked: () => {
							},
						},
						{
							buttontop: '200px',
							buttontext: 'Unkinked',
							isCorrect: true,
							onClicked: () => {
							},
						},
						{
							buttontop: '250px',
							buttontext: 'Clear',
							onClicked: () => {
							},
						}
					]
				}
			]
		});
		setTimeout(() => {
			this.scenario.gameManager.UiManager.updateUIInstance(this.MoveInstanceID, {
				loadQuiz: false,
			});
		}, 2000);
	}

	private getFooterCounts4() {
		var context = this;
		this.OldTalkCount = this.TalkCount;
		this.OldActionCount = this.ActionCount;
		if(this.TalkCount === 0 && this.ActionCount === 0) {
			context.scenario.updateFooter('0', '0', true, true);
			context.scenario.gameManager.UiManager.hideAllUis([constants.uiTags.Hud]);
			context.scenario.update508Window(Window508Type.Main);
			context.segment5PreloadUis();
		}
		else {
			context.scenario.updateFooter('0', this.ActionCount.toString(), true, false)
		};
	}

	private segment5PreloadUis() {
        var context = this;
		context.scenario.gameManager.UiManager.updateUIInstance(this.ActionInstanceID1, {
			talks: [
				{
					toppx: '50px',
					titletext: 'Catheter: Check Patency',
					onClicked: () => {
						this.segment5ActionPatency();
					},
					disable: () => this.Action6
				}
			]
		});
		this.scenario.gameManager.UiManager.hideUiInstance(this.ActionInstanceID1);

		context.ActionCount = 1;
		context.TalkCount = 0;
		context.getFooterCounts5();
	}

	private segment5ActionPatency() {
		var context = this;
		context.scenario.gameManager.UiManager.hideUiInstance(this.ActionInstanceID1);
		context.scenario.update508Window(Window508Type.TransformUI);
		this.MoveInstanceID = context.scenario.gameManager.UiManager.createUIInstance(constants.uiNames.TransformUI, {
			toptitle: 'Actions',
			toppx: '70px',
			loadQuiz: true,
			scenario: this,
			titletext: "Catheter: Check Patency",
			isTalks: true,
			extTop: true,
			extImg: 'PDEquipmentWithArrows',
			extText: 'No Patency',
			onSubmit: (updatedConfig: TransformUIConfig) => {
				if(this.CAbool === false) {
					this.scenario.appendToScenarioDataEntry((this.scenario as Scenario1).jonesNursesID, {
						title: context.scenario.catheter,
					}, context.scenario.allVisits, context.scenario.allHeaders, context.scenario.visit2);
					this.CAbool = true;
				}
				for(var i = 0; i < updatedConfig.quiz.length; i++) {
					var quiz = updatedConfig.quiz[i];
					for(var p = 0; p < quiz.selectedTalkIndices.length; p++) {
						var talk = quiz.talks[quiz.selectedTalkIndices[p]];
						this.scenario.appendToScenarioDataEntry((this.scenario as Scenario1).jonesNursesID, {
							header: p === 0 ? quiz.talktext2 : undefined,
							list: '<li>'+talk.buttontext+'</li>',
						}, context.scenario.allVisits, context.scenario.allHeaders, context.scenario.visit2, context.scenario.catheter)
					}
				}

				this.scenario.evaluateScoreForTalk(updatedConfig);
				this.Action6 = true;
				this.ActionCount = this.OldActionCount - 1;
				setTimeout(() => {
					context.scenario.update508Window(Window508Type.TalkActionsUI);
				}, 1000);
				context.scenario.gameManager.UiManager.hideUiInstance(this.MoveInstanceID);
				context.scenario.gameManager.UiManager.showUiInstance(this.ActionInstanceID1);
				context.getFooterCounts5();
			},
			quiz: [
				{
					quizheight: 2,
					quiztop: '5px',
					maxPoints: 500,
					binaryq: true,
					talktext1: 'Catheter',
					talktext2: 'Patency',
					talks: [
						{
							buttontop: '150px',
							buttontext: 'Yes',
							onClicked: () => {
							},
						},
						{
							buttontop: '200px',
							buttontext: 'No',
							isCorrect: true,
							onClicked: () => {
							},
						}
					]
				}
			]
		});
		setTimeout(() => {
			this.scenario.gameManager.UiManager.updateUIInstance(this.MoveInstanceID, {
				loadQuiz: false,
			});
		}, 2000);
	}

	private getFooterCounts5() {
		var context = this;
		this.OldTalkCount = this.TalkCount;
		this.OldActionCount = this.ActionCount;
		if(this.TalkCount === 0 && this.ActionCount === 0) {
			context.scenario.updateFooter('0', '0', true, true);
			context.scenario.gameManager.UiManager.hideAllUis([constants.uiTags.Hud]);
			context.scenario.update508Window(Window508Type.Main);
			context.segment6PreloadUis();
		}
		else {
			context.scenario.updateFooter('0', this.ActionCount.toString(), true, false)
		};
	}

	private segment6PreloadUis() {
        var context = this;
		context.scenario.gameManager.UiManager.updateUIInstance(this.ActionInstanceID1, {
			talks: [
				{
					toppx: '50px',
					titletext: 'Catheter: Irrigate',
					onClicked: () => {
						this.segment6ActionIrrigate();
					},
					disable: () => this.Action7
				}
			]
		});
		this.scenario.gameManager.UiManager.hideUiInstance(this.ActionInstanceID1);

		context.ActionCount = 1;
		context.TalkCount = 0;
		context.getFooterCounts6();
	}

	private segment6ActionIrrigate() {
		var context = this;
		context.scenario.gameManager.UiManager.hideUiInstance(this.ActionInstanceID1);
		context.scenario.update508Window(Window508Type.TransformUI);
		this.MoveInstanceID = context.scenario.gameManager.UiManager.createUIInstance(constants.uiNames.TransformUI, {
			toptitle: 'Actions',
			toppx: '70px',
			loadQuiz: true,
			titletext: "Catheter: Irrigate",
			isTalks: true,
			scenario: this,
			extTop: true,
			extImg: 'PDEquipmentWithSyringePart2', //will need to adjust this to cycle between part 2 and part 1
			extText: 'No urine flow.',
			onSubmit: (updatedConfig: TransformUIConfig) => {
				if(this.CAbool === false) {
					this.scenario.appendToScenarioDataEntry((this.scenario as Scenario1).jonesNursesID, {
						title: context.scenario.catheter,
					}, context.scenario.allVisits, context.scenario.allHeaders, context.scenario.visit2);
					this.CAbool = true;
				}
				for(var i = 0; i < updatedConfig.quiz.length; i++) {
					var quiz = updatedConfig.quiz[i];
					for(var p = 0; p < quiz.selectedTalkIndices.length; p++) {
						var talk = quiz.talks[quiz.selectedTalkIndices[p]];
						this.scenario.appendToScenarioDataEntry((this.scenario as Scenario1).jonesNursesID, {
							header: p === 0 ? quiz.talktext2 : undefined,
							list: '<li>'+talk.buttontext+'</li>',
						}, context.scenario.allVisits, context.scenario.allHeaders, context.scenario.visit2, context.scenario.catheter)
					}
				}

				this.scenario.evaluateScoreForTalk(updatedConfig);
				this.Action7 = true;
				this.ActionCount = this.OldActionCount - 1;
				setTimeout(() => {
					context.scenario.update508Window(Window508Type.TalkActionsUI);
				}, 1000);
				context.scenario.gameManager.UiManager.hideUiInstance(this.MoveInstanceID);
				context.scenario.gameManager.UiManager.showUiInstance(this.ActionInstanceID1);
				context.getFooterCounts6();
			},
			quiz: [
				{
					quizheight: 2,
					quiztop: '5px',
					maxPoints: 1000,
					binaryq: true,
					talktext1: 'Catheter',
					talktext2: 'Irrigate: Is there urine flow?',
					talks: [
						{
							buttontop: '150px',
							buttontext: 'Yes',
							onClicked: () => {
							},
						},
						{
							buttontop: '200px',
							buttontext: 'No',
							isCorrect: true,
							onClicked: () => {
							},
						}
					]
				}
			]
		});
		setTimeout(() => {
			this.scenario.gameManager.UiManager.updateUIInstance(this.MoveInstanceID, {
				loadQuiz: false,
			});
		}, 2000);
	}

	private getFooterCounts6() {
		var context = this;
		this.OldTalkCount = this.TalkCount;
		this.OldActionCount = this.ActionCount;
		if(this.TalkCount === 0 && this.ActionCount === 0) {
			context.scenario.updateFooter('0', '0', true, true);
			context.scenario.gameManager.UiManager.hideAllUis([constants.uiTags.Hud]);
			context.scenario.update508Window(Window508Type.Main);
			context.segment7PreloadUis();
		}
		else {
			context.scenario.updateFooter('0', this.ActionCount.toString(), true, false)
		};
	}

	private segment7PreloadUis() {
        var context = this;
		context.scenario.gameManager.UiManager.updateUIInstance(this.ActionInstanceID1, {
			talks: [
				{
					toppx: '50px',
					titletext: 'Call RRT',
					onClicked: () => {
						this.segment7ActionRRT();
					},
					disable: () => this.Action8
				}
			]
		});
		this.scenario.gameManager.UiManager.hideUiInstance(this.ActionInstanceID1);

		context.ActionCount = 1;
		context.TalkCount = 0;
		context.getFooterCounts7();
	}

	private getFooterCounts7() {
		var context = this;
		this.OldTalkCount = this.TalkCount;
		this.OldActionCount = this.ActionCount;
		if(this.TalkCount === 0 && this.ActionCount === 0) {
			context.scenario.gameManager.UiManager.hideAllUis([constants.uiTags.Hud]);
			context.scenario.updateFooter('0', '0', true, true);
			context.scenario.hideFooter();
			context.scenario.update508Window(Window508Type.Main);
			context.segment3showSbar();
		}
		else {
			context.scenario.updateFooter('0', this.ActionCount.toString(), true, false)
		};
	}

	private segment7ActionRRT() {
		var context = this;
		context.scenario.gameManager.UiManager.hideUiInstance(this.ActionInstanceID1);
		this.Action8 = true;
		this.ActionCount = this.OldActionCount - 1;
		context.scenario.updateFooter('0', '0', true, true);
		context.scenario.hideFooter();
		context.scenario.destroyAllUIInstances();
		context.scenario.gameManager.UiManager.hideAllUis([constants.uiTags.Hud]);
		this.playVideoChapter(this.chapterIds.chapterCinematic54, () => {
			context.scenario.gameManager.environment.blurFadeIn();
			context.getFooterCounts7();
		});
	}

	private segment3showSbar() {
		var context = this;
		context.scenario.update508Window(Window508Type.SbarUI)
		this.scenario.gameManager.UiManager.createUIInstance(constants.uiNames.SbarUI, {
			s: {
				maxPoints: 200,
				options: [
					{
						text: 'Status: Post TURP',
						isCorrect: true
					},
					{
						text: 'Attempted to irrigate',
						isCorrect: true
					},
					{
						text: 'No urine output',
						isCorrect: true
					},
					{
						text: 'Symptomatic',
						isCorrect: true
					}
				]
			},
			basic: this.scenario.getScenarioDataEntryItems((this.scenario as Scenario1).jonesBasicID),
			nurses: this.scenario.getScenarioDataEntryItems((this.scenario as Scenario1).jonesNursesID),
			r: {
				maxPoints: 150,
				options: [
					{
						text: 'Transfer care to RRT',
						isCorrect: true
					},
					{
						text: 'Medication',
						isCorrect: false
					},
					{
						text: 'Labs',
						isCorrect: false
					}
				]
			},
			correctFeedback: 'Good job, you have correctly relayed critical information. Please review the SBAR and continue.',
			incorrectFeedback: 'You have incorrectly relayed critical information. Accurate patient information ensures patient safety and quality care provided by medical staff and Providers. Please continue to review the corrected SBAR.',
			onSubmitted: (result: SbarUIConfig) => {
				this.scenario.evaluateScoreForSbar(result);
			},
			onClose: (result: SbarUIConfig) => {
				context.scenario.destroyAllUIInstances();
				context.segment1Part5Debrief();
			},
			onSetWindow: (window: Window508Type) => {
				context.scenario.update508Window(window);
			}
		});
	}
}